import apiClient from './apiClient';

const API_URL = '/tramites/plan-pago';

// Listar / filtrar trámites de Plan de Pago 27.705
export const getTramitesPlanPago = async (idCliente = null, idEstadoActual = null) => {
    const params = {};
    if (idCliente && idCliente.trim() !== '') params.idCliente = idCliente;
    if (idEstadoActual) params.idEstadoActual = idEstadoActual;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Detalle de un trámite (incluye hijos, checklist y panel de aportes)
export const getTramitePlanPagoById = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear un nuevo trámite de Plan de Pago
export const crearTramitePlanPago = async (tramiteData) => {
    try {
        const response = await apiClient.post(API_URL, tramiteData);
        return response.data;
    } catch (error) {
        console.error('Error al crear trámite de Plan de Pago:', error.response?.data || error.message);
        throw error;
    }
};

// Preview en vivo del checklist: GUARDA_DOC y SICAM siempre, RECON_SERVICIOS si aportesProvinciaNoTransferida
export const getChecklistFormularios = async (aportesProvinciaNoTransferida = false) => {
    const params = {};
    if (aportesProvinciaNoTransferida) params.aportesProvinciaNoTransferida = true;

    const response = await apiClient.get(`${API_URL}/formularios`, { params });
    return response.data;
};

// Editar datos del trámite (no el cliente)
export const actualizarTramitePlanPago = async (id, dto) => {
    const response = await apiClient.put(`${API_URL}/${id}`, dto);
    return response.data;
};

// Actualizar observaciones/comentarios (nota editable con firma)
export const actualizarComentariosPlanPago = async (id, comentarios) => {
    const response = await apiClient.patch(`${API_URL}/${id}/comentarios`, { comentarios });
    return response.data;
};

// Actualizar un ítem del checklist (marcar presentado / adjuntar archivo)
export const actualizarChecklistItem = async (idItem, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`${API_URL}/formularios/${idItem}`, { presentado, idArchivo });
    return response.data;
};

// Agregar una compra de meses (cantidad + monto; la fecha la pone el backend si no se manda)
export const agregarCompraPlanPago = async (idTramite, { cantidadMeses, monto, fechaCompra = null }) => {
    const response = await apiClient.post(`${API_URL}/${idTramite}/compras`, { cantidadMeses, monto, fechaCompra });
    return response.data;
};

// Eliminar una compra de meses
export const eliminarCompraPlanPago = async (idCompra) => {
    const response = await apiClient.delete(`${API_URL}/compras/${idCompra}`);
    return response.data;
};

const planPagoService = {
    getTramitesPlanPago,
    getTramitePlanPagoById,
    crearTramitePlanPago,
    getChecklistFormularios,
    actualizarChecklistItem,
    actualizarTramitePlanPago,
    actualizarComentariosPlanPago,
    agregarCompraPlanPago,
    eliminarCompraPlanPago,
};

export default planPagoService;

// Lo previsto para la apertura del plan (V267): { previstoMonotributo, previstoMeses27705,
// previstoObservacion, periodos24476Previstos: [{ desde: 'AAAA-MM-01', hasta: 'AAAA-MM-01' }] }.
export const actualizarPrevistoPlanPago = async (id, previsto) => {
    const response = await apiClient.put(`${API_URL}/${id}/previsto`, previsto);
    return response.data;
};
